import { Typography } from '@mui/material';
import { Box, Stack, styled } from '@mui/system';

import type { UserMessage } from '@/src/shared/types';
import { hoverPaleOrange } from '@/src/styles/theme/lightThemeOptions';

import { CopyMessageButton } from '../CopyMessageButton';
import { CardPrefix } from './CardPrefix';

const OuterStack = styled(Stack)({
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '2px',
});

const StyledBox = styled(Box)(({ theme }) => ({
    maxWidth: '80%',
    borderRadius: '6px',
    padding: theme.spacing(2, 4),
    backgroundColor: hoverPaleOrange,
}));

export const UserMessageCard = ({ message }: { message: UserMessage }) => {
    const { content, timestamp } = message;
    return (
        <OuterStack className="chat-flow-card">
            <CardPrefix timestamp={timestamp} />
            <StyledBox>
                <Typography sx={{ fontSize: '14px' }} variant="body1">
                    {content}
                </Typography>
            </StyledBox>
            <CopyMessageButton message={content} />
        </OuterStack>
    );
};
